<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <div class="md-card">
        <div class="md-card-header md-card-header-icon md-card-header-rose">
          <div class="card-icon">
            <i class="material-icons">settings</i>
          </div>
          <h4 class="title">{{ title }}</h4>

          <slot name="top"></slot>
        </div>
        <div class="md-card-content">
          <collapse
            :open="true"
            :collapse="['Futuras']"
            icon="keyboard_arrow_up"
            color-collapse="rose"
            key="2332"
          >
            <template slot="md-collapse-pane-1">
              <MyClasses
                @deleted="deletedClass"
                :key="reloadclasses"
                :all="false"
                :owner="owner"
              />
            </template>
          </collapse>
          <collapse
            :open="open"
            :collapse="['Pasadas']"
            icon="keyboard_arrow_up"
            color-collapse="rose"
            key="2332"
          >
            <template slot="md-collapse-pane-1">
              <MyClasses
                @deleted="deletedClass"
                :key="reloadclasses"
                :all="true"
                :owner="owner"
              />
            </template>
          </collapse>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
// Mock function to replace non-existent import
const createAccessAction = async (data) => {
  console.warn(
    "createAccessAction is not available - Orders actions module was removed"
  );
  return { success: false, message: "Create access not available" };
};
import { getUserAction, getMyProfileAction } from "@/pages/Users/actions";
import { i18n } from "@/i18n";
import { format } from "date-fns";
import NewUserForm from "@/pages/Dashboard/Pages/UserProfile/NewUserForm.vue";
import permissionsMixin from "@/mixins/permissionsMixin";
import { logoutAction } from "@/pages/Auth/actions";
import { Collapse } from "@/components";

import { MyClasses, ScheduleWeekGym } from "@/components";

export default {
  mixins: [permissionsMixin],
  components: {
    MyClasses,
    ScheduleWeekGym,
    Collapse,
  },
  data() {
    return {
      reloadclasses: 3232,
      subdomain: "",
      open: false,
      owner: false,
    };
  },
  created() {
    this.subdomain = window.location.hostname;

    if (this.isClientGym()) {
      this.owner = false;
      this.title = "Mis Clases";
    } else {
      this.owner = true;
      this.title = "Creadas por mí";
    }
  },
  methods: {
    deletedClass() {
      this.reloadclasses++;
    },
  },
};
</script>
